






















































































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { Component, Mixins } from 'vue-property-decorator';
import { IUser } from '@resclick/data-access';

@Component
export default class ChangeCompanyModal extends Mixins(ModalMixin) {
  form: CrsForm<'orders', 'update'> = this.$crsForm('orders', 'update', {
    agent: '',
    company: '',
    bookingDate: new Date(),
  });

  getUserName(user: IUser) {
    if (typeof user === 'object') {
      return `${user.name} ${user.surname}`;
    }
    return '';
  }

  preSubmit() {
    this.form.fields.type = 'CHANGE';
  }

  async getForm() {
    return compass.do('orders', 'findOne', { params: { orderId: this.id } });
  }
}
